import { Component } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { PropgService } from 'src/app/services/propg-service'

type TabState = 'inicial' | 'desatualizada' | 'carregando' | 'pronto' | 'sem_resultado'

@Component({
  selector: 'app-pesquisa-departamento',
  templateUrl: './pesquisa-departamento.component.html',
  styleUrls: ['./pesquisa-departamento.component.css'],
  standalone: false
})
export class PesquisaDepartamentoComponent {
  lastSearch: string = ''

  dataResponsavelOficial?: any
  dataResponsavelVigente?: any
  dataAssessorVigente: any[] = []

  tabStateResponsavelOficial: TabState = 'inicial'
  tabStateResponsavelVigente: TabState = 'inicial'
  tabStateAssessorVigente: TabState = 'inicial'

  form = new FormGroup({
    id: new FormControl('', Validators.required),
  })

  constructor(private propgService: PropgService) {}

  getDataResponsavelOficial(): TabState {
    if (this.tabStateResponsavelOficial !== 'desatualizada') return this.tabStateResponsavelOficial

    this.tabStateResponsavelOficial = 'carregando'
    this.propgService.departamentoResponsavelOficial(this.form.controls['id'].getRawValue()!).subscribe(data => {
      this.dataResponsavelOficial = data
      this.tabStateResponsavelOficial = data != null && data.length > 0 ? 'pronto' : 'sem_resultado'
    })
    this.dataResponsavelOficial = [{ horario: new Date() }]

    return 'carregando'
  }

  getDataResponsavelVigente(): TabState {
    if (this.tabStateResponsavelVigente !== 'desatualizada') return this.tabStateResponsavelVigente

    this.tabStateResponsavelVigente = 'carregando'
    this.propgService.departamentoResponsavelVigente(this.form.controls['id'].getRawValue()!).subscribe(data => {
      this.dataResponsavelVigente = data
      this.tabStateResponsavelVigente = data != null && data.length > 0 ? 'pronto' : 'sem_resultado'
    })
    this.dataResponsavelVigente = [{ horario: new Date() }]

    return this.tabStateResponsavelVigente
  }

  getDataAssessorVigente(): TabState {
    if (this.tabStateAssessorVigente !== 'desatualizada') return this.tabStateAssessorVigente

    this.tabStateAssessorVigente = 'carregando'
    this.propgService.departamentoAssessorVigente(this.form.controls['id'].getRawValue()!).subscribe(data => {
      this.dataAssessorVigente = data
      this.tabStateAssessorVigente = data != null && data.length > 0 ? 'pronto' : 'sem_resultado'
    })
    this.dataAssessorVigente = [{ horario: new Date() }]

    return this.tabStateAssessorVigente
  }

  filtrar() {
    if (this.form.controls['id'].getRawValue()!.length) {
      this.lastSearch = this.form.controls['id'].getRawValue()!
      this.tabStateResponsavelOficial = this.tabStateResponsavelVigente = this.tabStateAssessorVigente = 'desatualizada'
    }
  }
}
